import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';

import Utils from '../../../Services/Utils';

import InputText from '../Text';
import InputWrapper from '../WrapperInput';
import withShallowComparison from '../../Common/withShallowComparisonUpdate';
import Icon from "../../Common/Icon";
import {ReactComponent as DateIcon} from "../../../../img/icon-date.svg";

const formatDate1 = /^(0[1-9]|1[0-2])[\/\-\.](0[1-9]|1\d|2\d|3[01])[\/\-\.](19|20)\d{2}$/;
const formatDate2 = /^(?:(?:31[\/\-\.](?:0?[13578]|1[02]))\1|(?:(?:29|30)[\/\-\.](?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{4})$|^(?:29[\/\-\.]0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])[\/\-\.](?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{4})$/;

class InputDate extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      mask: this.props.mask || '99-99-9999'
    };
    this.dateInput = React.createRef();
  }

  componentDidMount() {
    this.initValidate();
  }

  componentDidUpdate() {
    this.initValidate();
  }

  initValidate = () => {
    const { value, onError, error } = this.props;
    const newError = this.validate(value);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  }

  formatValid = (value) => {
    const format1 = formatDate1.test(value);
    const format2 = formatDate2.test(value);
    return format1 || format2;
  };

  validate = (value) => {
    const { required, validators } = this.props;
    if (required && Utils.isNull(value)) return 'This field is required.';
    for (const validator of validators || []) {
      if (validator(value)) return validator(value);
    }
    return '';
  };

  handleInputChange = (e) => {
    const { onChange, onError, error, disabled } = this.props;
    if (disabled) return;
    const value = e && e.target ? e.target.value : e;
    let format = 'MM-DD-YYYY';
    let newError = this.validate(value);
    if (newError === '') {
      newError = (!Utils.isNull(value) && !this.formatValid(value)) ? 'Invalid date format.' : '';
    }
    if (onChange) {
      if (!newError) {
        if (formatDate1.test(value)) {
          onChange(value ? Utils.formatDate(moment(value, format).toDate()) : null);
        }
        else {
          format = 'DD-MM-YYYY';
          onChange(value ? Utils.formatDate(moment(value, format).toDate()) : null);
        }
      }
      else if (!value || value === '__-__-____') {
        onChange(null);
      }
    }
    if (onError && !Utils.equals(newError, error)) onError(newError);
  };

  handleChange = (e) => {
    const { onChange, onError, error, disabled } = this.props;
    if (disabled) return;
    const value = e && e.target ? e.target.value : e;
    const newError = this.validate(value);
    if (onChange) onChange(value ? Utils.formatDate(value) : null);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  };

  handleOnSelect = (val, event)  => {
    try {
      if ($(event.target).closest('.WrapperSection_Field').nextAll().find('input,select,option,textarea,button,radio,checkbox').length > 0) {
        if (!event.defaultPrevented && event.type === "click") {
          $(event.target).closest('.WrapperSection_Field').nextAll().find('input,select,option,textarea,button,radio,checkbox').first().trigger('focus');
        }
        else {
          if (event.type === "blur" && this.dateInput && this.dateInput.current && event.relatedTarget?.className === "react-datepicker__tab-loop__start") {
            $(event.target).closest('.WrapperSection_Field').nextAll().find('input,select,option,textarea,button,radio,checkbox').first().trigger('focus');
            setTimeout(() => {
              this.dateInput.current.setOpen(false);
            }, 100);
          }
        }
      }
      else {
        var elments = $(event.target).closest('.WrapperSection_Field').closest('.WrapperDynamicSection').nextAll();
        for (let i = 0; i < elments.length; i++) {
          if ($(elments[i]).find('input,select,option,textarea,button,radio,checkbox').length > 0) {
            if ((!event.defaultPrevented && event.type === "click") || (event.defaultPrevented && event.type === "keydown")) {
              $(elments[i]).find('input,select,option,textarea,button,radio,checkbox').first().trigger('focus');
            }
            else if(event.type === "blur" && this.dateInput && this.dateInput.current && event.relatedTarget?.className === "react-datepicker__tab-loop__start") {
              $(elments[i]).find('input,select,option,textarea,button,radio,checkbox').first().trigger('focus');
              setTimeout(() => {
                this.dateInput.current.setOpen(false);
              }, 100);
            }
            break;
          }
        }
      }
    }
    catch (ex) {
    }
  };

  onKeyDown = (e) => {
    if (e.key === 'Tab') {
      this.dateInput.current.setOpen(false);
    }
  };

  render() {
    const {
      className,
      label,
      labelhtml,
      error,
      disabled,
      required,
      value,
      startDate,
      endDate,
      formatDate,
      inline,
      todayButton
    } = this.props;

    const WrapperProps = {
      className,
      label,
      labelhtml,
      error,
      required
    };
    
    let minDate = startDate ? moment(startDate).toDate() : undefined;
    if (!minDate) {
      minDate = new Date();
      minDate.setFullYear( minDate.getFullYear() - 100 );
    }
    let maxDate = endDate ? moment(endDate).toDate() : undefined;
    if (!maxDate) {
      maxDate = new Date();
      maxDate.setFullYear( maxDate.getFullYear() + 100 );
    }
    const valueDate = value ? moment(value).toDate() : undefined;
    const formatD = formatDate || 'MM-dd-yyyy';
    const withPortal = Boolean(this.props.withPortal) || false;
    const popperPlacement = this.props.popperPlacement || 'bottom-start';

    return (
      <InputWrapper { ...WrapperProps }>
        <DatePicker
          customInput={
            <InputText
               value={ value }
               required={ required }
               disabled={ disabled }
               disablechange='true'
               debounce={ 0 }
               mask={ this.state.mask }
            />
          }
          selected={ valueDate }
          onChange={ this.handleChange }
          onChangeRaw={ this.handleInputChange }
          inline={ inline }
          disabled={ disabled }
          minDate={ minDate }
          maxDate={ maxDate }
          dateFormat={ formatD }
          className='InputDate'
          todayButton={ todayButton ? 'Today' : false }
          popperPlacement={ popperPlacement }
          withPortal={ withPortal }
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          onSelect={ this.handleOnSelect }
          ref={this.dateInput}
          onKeyDown={this.onKeyDown}
        />
        <Icon width='15' height='15' color='secondaryColor' position='Right'>
          <DateIcon alt='icon-date'/>
        </Icon>
      </InputWrapper>
    );
  }
}

InputDate.propTypes = {
  className: PropTypes.string,
  mask: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  popperPlacement: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  formatDate: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  withPortal: PropTypes.bool,
  onChange: PropTypes.func,
  onError: PropTypes.func,
};

export default withShallowComparison(InputDate, ['onChange', 'onError']);